import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { useEffect, useMemo } from 'react'
import useRelatorioSaldoEstoque, { LOAD_MESSAGE } from './RelatorioSaldoEstoqueHook'
import {
  Btn,
  CustomDataTableHeader,
  CustomMultiSelect,
  CustomPanel,
  NumeroDecimal,
  PageHeader,
} from '../../../../components'
import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { parseToMysqlFormat } from '../../../../services/util/date.service'

function RelatorioSaldoEstoque({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useRelatorioSaldoEstoque()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getRelatorioSaldoEstoque(selectedTp, state.selectedEstoques, state.checkpoint)
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const filteredProdutos = useMemo(() => {
    if (!state.selectedCompanies || state.selectedCompanies.length === 0) return state.produtos
    const allowed = state.selectedCompanies.map(c => c.id) // id === company string
    return state.produtos.filter(p => allowed.includes(p.company))
  }, [state.produtos, state.selectedCompanies])

  const onBtnExportarExcelClick = () => {
    if (filteredProdutos.length) {
      const colunas = [['Código', 'Produto', 'Empresa', 'Lote', 'Validade', 'Qte']]
      filteredProdutos.forEach(p =>
        colunas.push([p.product_code, p.product, p.company, p.lote, p.validade, p.quantidade]),
      )
      gerarArquivoExcel(
        `saldo em ${parseToMysqlFormat(state.checkpoint)}`,
        colunas,
        'saldo_estoque.xlsx',
      )
    } else {
      dispatch(showMessageBox(null, 'Não existem informações para serem exportadas'))
    }
  }

  return (
    <div>
      <PageHeader>8.16 - Relatório de Saldo de Estoque</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomMultiSelect
                disabled={!selectedTp}
                placeholder="Selecione um Estoque"
                optionLabel="name"
                options={state.estoques}
                label="Estoques"
                onChange={value => localDispatch.onChange('selectedEstoques', value)}
                value={state.selectedEstoques}
              />
            </div>
            <div className="p-col-3">
              <CustomMultiSelect
                disabled={state.companies.length === 0} // habilita somente após a pesquisa
                placeholder="Empresas retornadas"
                optionLabel="name"
                options={state.companies}
                label="Empresas"
                onChange={value => localDispatch.onChange('selectedCompanies', value)}
                value={state.selectedCompanies}
              />
            </div>
            <div className="p-col-6" style={{ marginTop: 35 }}>
              <Btn disabled={!selectedTp} onClick={() => localDispatch.onClickPesquisar()}>
                Pesquisar
              </Btn>
              <Btn
                disabled={!selectedTp}
                onClick={onBtnExportarExcelClick}
                style={{ display: 'inline-block', marginLeft: 16 }}
              >
                Exportar Excel
              </Btn>
            </div>
          </div>
          <div className="p-col-12">
            <DataTable
              value={filteredProdutos}
              header={
                <CustomDataTableHeader
                  onChange={value => localDispatch.onChange('globalFilter', value)}
                />
              }
              globalFilter={state.globalFilter}
              paginator
              rows={10}
              emptyMessage="Nenhuma posição a ser exibida"
            >
              <Column
                field="product_code"
                header="Código"
                style={tableCellCentered(150)}
                sortable
              />
              <Column field="product" header="Produto" sortable />
              <Column field="company" header="Empresa" style={tableCellCentered(150)} sortable />
              <Column field="lote" header="Lote" style={tableCellCentered(150)} sortable />
              <Column field="validade" header="Validade" style={tableCellCentered(150)} sortable />
              <Column
                field="quantidade"
                header="Qte"
                style={tableCellCentered(150)}
                sortable
                body={row => <NumeroDecimal>{row.quantidade}</NumeroDecimal>}
              />
            </DataTable>
          </div>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(RelatorioSaldoEstoque))
